import { Mail } from "lucide-react";
import { ProfileImg } from "../components/ProfileIMG";

/* This view represents what the user sees when they are at their profile page. It displays contact
   information, profile picture, and what the user is currently reading etc.*/



   export function MyProfileView(props){
      console.log("profile name",props.user.username)
      
      return(
         <div className="min-h-screen bg-sky-50">
            <div className="max-w-6xl mx-auto px-4 py-8">
            {/* Profile Header */}
               <div className="mb-8 bg-white rounded-xl p-6 border border-blue-100">
                  <div className="flex flex-row flex-wrap gap-6 items-center">

                  {/* Profile image component */}
                  <ProfileImg svgString = {props.user.userIMG} className={"w-24 h-24 rounded-full border-4 border-blue-100 bg-white"}/>


               {/* User info */}
                     <div className="flex-1">
                        <div className="flex items-center gap-3 mb-2">
                        <h3 className="text-base text-blue-900 font-bold">{props.user.username}</h3>

                        </div>
                     <p className="text-blue-600 flex items-center gap-2">
                     <Mail className="w-4 h-4" />
                     {props.user.userEmail}
                      </p>
                     </div>
               </div>
            </div>
         </div>
      </div>
      );
   }

